import { render, staticRenderFns } from "./CartaoBase.vue?vue&type=template&id=f9c273ee&scoped=true"
import script from "./CartaoBase.vue?vue&type=script&setup=true&lang=js"
export * from "./CartaoBase.vue?vue&type=script&setup=true&lang=js"
import style0 from "./CartaoBase.vue?vue&type=style&index=0&id=f9c273ee&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f9c273ee",
  null
  
)

export default component.exports